export enum EPaymentIframes {
    ADD_CARD,
    BALANCE,
}
